import CloseIcon from '@material-ui/icons/Close';
import { I18n, Translate } from 'src/translations/i18n';
import CheckIcon from '@material-ui/icons/Check';
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { SELECT_ELEMENT_HEIGHT } from 'src/components/Inputs/DropDownSelector/instruments';
const useStyles = makeStyles(({ palette }) => ({
    selectLabelStyle: {
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        height: `${SELECT_ELEMENT_HEIGHT}px`,
        userSelect: 'none',
        cursor: 'pointer',
        backgroundColor: palette.ddSelector.item,
        color: palette.ddSelector.color,
        '&:hover': {
            background: palette.ddSelector.itemHover
        }
    },
    centered: {
        display: 'flex',
        alignItems: 'center'
    }
}));
function SelectAllElement({ onClick, isAllSelected, style }) {
    const classes = useStyles();
    const cancelAllTxt = `${I18n.t('Cancel')} ${I18n.t('All')}`;
    return (React.createElement("div", { className: "select-label bold", style: style },
        React.createElement("div", { className: classes.selectLabelStyle, onClick: onClick }, isAllSelected
            ? (React.createElement("div", { className: classes.centered },
                React.createElement(CloseIcon, { className: "multi-select-icon" }),
                cancelAllTxt))
            : (React.createElement("div", { className: classes.centered },
                React.createElement(CheckIcon, { className: "multi-select-icon" }),
                React.createElement(Translate, { value: "ChooseAll" }))))));
}
export default SelectAllElement;
